export const REACT_TOKEN = 'react-token'

export const SXP_BOTIDID = 'sxp-botidid'
